import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => {
  return {
    listItem: {
      maxWidth: '100%',
      boxSizing: 'border-box',
      overflow: 'hidden',
      '&.MuiListItemButton-root:has(.MuiCheckbox-root)': {
        paddingBlock: theme.spacing(0.25),
      },
      '& .MuiListItemText-root': {
        marginBlock: 0,
      },
      '& .MuiListItemText-root .MuiListItemText-secondary': {
        marginTop: 0,
      },
    },
    listItemWithSecondary: {
      '&.MuiListItemButton-root:has(.MuiCheckbox-root)': {
        paddingBlock: theme.spacing(0.5),
      },
      '& .MuiListItemText-root .MuiListItemText-primary': {
        fontSize: theme.typography.micro1.fontSize,
        lineHeight: theme.typography.micro1.lineHeight,
      },
      '& .MuiListItemText-root .MuiListItemText-secondary': {
        fontSize: theme.typography.micro2.fontSize,
        lineHeight: theme.typography.micro2.lineHeight,
      },
    },
    optionText: {
      '& > span': {
        maxWidth: '86%',
      },
    },
    menuItemButton: {
      gap: 1,
    },
  };
});

export default useStyles;
